/**
 * c-header.js - カスタムヘッダーのJavaScript
 * ドロワーメニューとアコーディオンの制御
 */

class CHeaderDrawer {
  constructor() {
    this.drawer = document.getElementById('c-header-drawer');
    if (!this.drawer) return;

    this.overlay = this.drawer.querySelector('.c-header-drawer__overlay');
    this.content = this.drawer.querySelector('.c-header-drawer__content');
    this.openButton = document.querySelector('[data-drawer-open]');
    this.closeButtons = this.drawer.querySelectorAll('[data-drawer-close]');
    this.accordionToggles = this.drawer.querySelectorAll('[data-accordion-toggle]');
    
    this.isAnimating = false;
    this.focusableElements = [];
    this.lastFocusedElement = null;

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupFocusTrap();
  }

  setupEventListeners() {
    // 開くボタン
    if (this.openButton) {
      this.openButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }

    // 閉じるボタン（複数対応）
    this.closeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    // アコーディオントグル
    this.accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(toggle);
      });
    });

  }

  setupFocusTrap() {
    this.focusableElements = this.drawer.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
  }

  open() {
    if (this.isAnimating || this.isOpen()) return;

    this.isAnimating = true;
    this.lastFocusedElement = document.activeElement;

    // ドロワーを開く
    this.drawer.classList.add('c-header-drawer--open');
    this.drawer.setAttribute('aria-hidden', 'false');

    // body スクロールを無効化
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    // アニメーション完了後
    setTimeout(() => {
      this.isAnimating = false;
      
      // 最初のフォーカス可能要素にフォーカス
      if (this.focusableElements.length > 0) {
        this.focusableElements[0].focus();
      }
    }, 300);
  }

  close() {
    if (this.isAnimating || !this.isOpen()) return;

    this.isAnimating = true;

    // ドロワーを閉じる
    this.drawer.classList.remove('c-header-drawer--open');
    this.drawer.setAttribute('aria-hidden', 'true');

    // body スクロールを有効化
    document.body.style.overflow = '';
    document.body.style.touchAction = '';

    // アニメーション完了後
    setTimeout(() => {
      this.isAnimating = false;
      
      // 元のフォーカスを復元
      if (this.lastFocusedElement) {
        this.lastFocusedElement.focus();
      }
    }, 300);
  }

  isOpen() {
    return this.drawer.classList.contains('c-header-drawer--open');
  }

  toggleAccordion(toggle) {
    const accordion = toggle.closest('[data-accordion]');
    if (!accordion) return;

    const content = accordion.querySelector('.c-header-drawer__accordion-content');
    if (!content) return;

    const isOpen = accordion.classList.contains('c-header-drawer__accordion--open');

    if (isOpen) {
      // 閉じる
      accordion.classList.remove('c-header-drawer__accordion--open');
      content.style.maxHeight = '0';
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      // 開く
      accordion.classList.add('c-header-drawer__accordion--open');
      content.style.maxHeight = content.scrollHeight + 'px';
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  // すべてのアコーディオンを閉じる
  closeAllAccordions() {
    const accordions = this.drawer.querySelectorAll('[data-accordion]');
    accordions.forEach(accordion => {
      const content = accordion.querySelector('.c-header-drawer__accordion-content');
      const toggle = accordion.querySelector('[data-accordion-toggle]');
      
      accordion.classList.remove('c-header-drawer__accordion--open');
      if (content) {
        content.style.maxHeight = '0';
      }
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
}

/**
 * 初期化
 */
function initCHeader() {
  new CHeaderDrawer();
}

// DOM読み込み完了後に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCHeader);
} else {
  initCHeader();
}

// Shopify Theme Editor対応
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('shopify-section--c-header')) {
      initCHeader();
    }
  });
}
